import { useLoaderData } from '@remix-run/react'
import { motion } from 'framer-motion'
import { type loader as rootLoader } from '#app/root.tsx'
import NavigationBar from './navigation-bar/navigation-bar.tsx'
import { useNavigationContext } from './navigation-context.tsx'
import { StickyNavigation } from './sticky-navigation.tsx'

export function NavigationWrapper() {
	const {
		isWorkSlugPage,
		isEducationSlugPage,
		shouldShowWorkNavigation,
		shouldShowEducationNavigation,
		workNavigation,
		educationNavigation,
		currentSlug,
	} = useNavigationContext()
	const data = useLoaderData<typeof rootLoader>()

	return (
		<motion.header
			className="fixed top-0 z-50 flex w-full flex-col border-b-2 bg-background/80 backdrop-blur-sm"
			initial={{ y: -20, opacity: 0 }}
			animate={{ y: 0, opacity: 1 }}
			transition={{ duration: 0.5 }}
		>
			{/* Main Navigation Bar */}
			<nav aria-label="Main navigation" className="relative p-2">
				<NavigationBar theme={data.requestInfo.userPrefs.theme ?? undefined} />
			</nav>

			{/* Work Experience Navigation - Hide on work detail pages since they have breadcrumbs */}
			{shouldShowWorkNavigation &&
				workNavigation &&
				currentSlug &&
				!isWorkSlugPage && (
					<StickyNavigation
						allSlugs={
							workNavigation
								.map((item) => item.slug)
								.filter((slug) => slug !== null) as string[]
						}
						currentSlug={currentSlug}
					/>
				)}

			{/* Education Navigation - Hide on education detail pages since they have breadcrumbs */}
			{shouldShowEducationNavigation &&
				educationNavigation &&
				currentSlug &&
				!isEducationSlugPage && (
					<StickyNavigation
						allSlugs={
							educationNavigation
								.map((item) => item.slug)
								.filter((slug) => slug !== null) as string[]
						}
						currentSlug={currentSlug}
					/>
				)}
		</motion.header>
	)
}
